/* Apparition du  menu stciky si on scroll en dessous des onglets*/
window.onscroll = function() {
    try {
        var onglets = document.getElementById('tabs-onglet');
        var header = document.getElementById('header');
        
        if (onglets.getBoundingClientRect().top < (header.getBoundingClientRect().height - onglets.getBoundingClientRect().height)) {
            document.getElementById("page").classList.add("menu-sticky");
        } else {
            document.getElementById("page").classList.remove("menu-sticky");
            document.getElementById("menu-sticky-contact").classList.remove("show");
        }
    }
     catch (ex){
        return;
     }
};

jQuery(function() {
    try {        
        // Bloc de recherche des offres
        if (jQuery("#section-menu-sticky-contact").length>0) {
            $("#section-menu-sticky-contact .close-sticky-menu").on('click', function() {
              $("#menu-sticky-contact").removeClass("show");
            })
        }        
    }     
    catch (ex) {
        console.error(ex);
    }
});